import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MyTrainingsList from "../Components/MyTrainingsList";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./MyTrainings.css";

function MyTrainings() {
  const [trainings, setTrainings] = useState([]);
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [trainingToDelete, setTrainingToDelete] = useState(null);

  const { state } = useContext(AuthContext);

  let { uid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings/user/trainings/${uid}`,
        data: { language: state.language },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setTrainings(response.data.trainings);
      setName(response.data.userName);
    }
    fetch();
    setIsLoading(false);
  }, [state.language, state.token, uid]);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setTrainingToDelete(id);
    setShow(true);
  };

  const deleteTraining = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings/delete/training`,
        data: { trainingId: trainingToDelete, userId: uid },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings/user/trainings/${uid}`,
        data: { language: state.language },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setTrainings(response.data.trainings);
      setName(response.data.userName);
      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col className="mytrainings">
            <h2>
              {t("Capacitaciones.MisCapacitaciones.Titulo")} - {name}
            </h2>
          </Col>
        </Row>
        <Row>
          {trainings.length === 0 ? (
            <Col className="empty-trainings center">
              <h5>{t("Capacitaciones.MisCapacitaciones.SinCapacitaciones")}</h5>
            </Col>
          ) : (
            <MyTrainingsList
              trainings={trainings}
              userId={uid}
              stateUserId={state.userId}
              role={state.role}
              language={state.language}
              handleShow={handleShow}
            />
          )}
        </Row>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Capacitaciones.MisCapacitaciones.ModalTitulo")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {t("Capacitaciones.MisCapacitaciones.ModalPregunta")}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Capacitaciones.MisCapacitaciones.Cancelar")}
            </Button>
            <Button
              variant="primary"
              onClick={() => deleteTraining(trainingToDelete)}
            >
              {t("Capacitaciones.MisCapacitaciones.Eliminar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default MyTrainings;
